import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check-circle-solid",
  "use": "icon-check-circle-solid-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-check-circle-solid\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#5ab300\" d=\"M2 16c0 7.8 6.2 14 14 14s14-6.2 14-14S23.8 2 16 2 2 8.2 2 16\" /><path fill=\"#fff\" d=\"M14.773 23.65 9.4 18.063l1.445-1.933 3.577 3.37 6.436-9.885 1.865 1.285z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol